import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import {
  companiesDataChangeById,
  moderatedCompaniesRemoveById,
  companiesDataAdded,
  changeDataByCompanyType,
} from '../../store/companies';
import CompaniesView from './companies-view';
import { AdminService } from '../../services/requests';
import { ACCEPT, BANNED } from '../../services/companies-statuses';
import CompaniesHelper from '../../store/companies/action';
import { combineDataToUniqueArray } from '../../services/functions';
import { changeValue } from '../../store/statistic';

const CompaniesContainer = (props) => {
  const [activeTab, setActiveTab] = useState(Number(sessionStorage.getItem('activeTab')) || 0);

  const savedData = JSON.parse(sessionStorage.getItem(renderDataObjectName()));

  const [allCompaniesPageNumber, setAllCompaniesPageNumber] = useState(2);
  const [moderatedCompaniesPageNumber, setModeratedCompaniesPageNumber] = useState(2);
  const [declinedCompaniesPageNumber, setDeclinedCompaniesPageNumber] = useState(2);
  const [updateDataLoading, setUpdateDataLoading] = useState(false);
  const [directionStr, setDirectionStr] = useState(savedData?.direction || 'desc');

  function renderDataObjectName() {
    switch (activeTab) {
      case 0:
        return 'moderatedCompanies';
      case 1:
        return 'allCompanies';
      case 2:
        return 'declinedCompanies';
      default:
        return 'allCompanies';
    }
  }

  const acceptCompany = async (companyId, param) => {
    setUpdateDataLoading(true);
    try {
      const res = await AdminService.acceptCompany({ companyId });

      if (res === 'OK') {
        props.companiesDataChangeById({
          data: {
            status: ACCEPT,
          },
          id: companyId,
        });
        props.moderatedCompaniesRemoveById({
          data: props.companies.moderatedCompanies.data,
          id: companyId,
        });
        if (param === 'del') {
          props.changeValue({
            key: 'moderatedCompanies',
            value: props.statistic.data.moderatedCompanies - 1,
          });
        }
        setUpdateDataLoading(false);
      }
    } catch (err) {
      setUpdateDataLoading(false);
    }
  };

  const banCompany = async (companyId, param) => {
    setUpdateDataLoading(true);
    try {
      const res = await AdminService.banCompany({ companyId });

      if (res === 'OK') {
        props.companiesDataChangeById({
          data: {
            status: BANNED,
          },
          id: companyId,
        });
        props.moderatedCompaniesRemoveById({
          data: props.companies.moderatedCompanies.data,
          id: companyId,
        });
        if (param === 'del') {
          props.changeValue({
            key: 'moderatedCompanies',
            value: props.statistic.data.moderatedCompanies - 1,
          });
        }
        setUpdateDataLoading(false);
      }
    } catch (err) {
      setUpdateDataLoading(false);
    }
  };

  const refreshAction = () => {
    setAllCompaniesPageNumber(2);
    setModeratedCompaniesPageNumber(2);
    setDeclinedCompaniesPageNumber(2);
    setDirectionStr(props.companies[renderDataObjectName()]?.direction || directionStr || 'desc');
    props.getAllCompanies();
    props.getModeratedCompanies();
    props.getDeclinedCompanies();
  };

  const directionRenderStr = () => {
    if (directionStr === 'desc' || !directionStr) {
      setDirectionStr('asc');
      return 'asc';
    }
    setDirectionStr('desc');
    return 'desc';
  };

  const sortCompaniesInModeratedListByDateOfCreation = async (direction) => {
    setUpdateDataLoading(true);
    try {
      setModeratedCompaniesPageNumber(2);
      const res = await AdminService.getCompaniesInModerated(1, direction);
      if (res) {
        const key = 'moderatedCompanies'
        sessionStorage.setItem(key, JSON.stringify({
          ...res,
          direction,
        }));
        props.changeDataByCompanyType({ key, data: { ...res, direction } });
      }
      setUpdateDataLoading(false);
    } catch (err) {
      setUpdateDataLoading(false);
    }
  };

  const sortAllCompaniesListByDateOfCreation = async (direction) => {
    setUpdateDataLoading(true);
    try {
      setAllCompaniesPageNumber(2);
      const res = await AdminService.getAllCompanies(1, direction);
      if (res) {
        const key = 'allCompanies';
        sessionStorage.setItem(key, JSON.stringify({
          ...res,
          direction,
        }));
        props.changeDataByCompanyType({ key, data: { ...res, direction } });
      }
      setUpdateDataLoading(false);
    } catch (err) {
      setUpdateDataLoading(false);
    }
  };

  const sortDeclinedCompaniesListByDateOfCreation = async (direction) => {
    setUpdateDataLoading(true);
    try {
      setDeclinedCompaniesPageNumber(2);
      const res = await AdminService.getDeclinedCompanies(1, direction);
      if (res) {
        const key = 'declinedCompanies';
        sessionStorage.setItem(key, JSON.stringify({
          ...res,
          direction,
        }));
        props.changeDataByCompanyType({ key, data: { ...res, direction } });
      }
      setUpdateDataLoading(false);
    } catch (err) {
      setUpdateDataLoading(false);
    }
  };

  const sortCompanies = (direction) => {
    setDirectionStr(direction || 'desc');
    if (activeTab === 0) {
      sortCompaniesInModeratedListByDateOfCreation(direction);
    } else if (activeTab === 1) {
      sortAllCompaniesListByDateOfCreation(direction);
    } else if (activeTab === 2) {
      sortDeclinedCompaniesListByDateOfCreation(direction);
    }
  };

  const handleOnDocumentBottom = async () => {
    if (!updateDataLoading && !props.companies.allCompanies.loading && !props.companies.moderatedCompanies.loading) {
      if (activeTab === 1 && !props.companies.allCompanies.last) {
        setAllCompaniesPageNumber(allCompaniesPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getAllCompanies(allCompaniesPageNumber, props.companies.allCompanies.direction || 'desc');
          if (res) {
            props.companiesDataAdded({
              key: 'allCompanies',
              data: combineDataToUniqueArray(props.companies.allCompanies.data, res.data, 'companyId'),
              last: res.last,
              direction: directionStr,
            });
            setUpdateDataLoading(false);
          }
        } catch (res) {
          setUpdateDataLoading(false);
        }
      }

      if (activeTab === 0 && !props.companies.moderatedCompanies.last) {
        setModeratedCompaniesPageNumber(moderatedCompaniesPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getCompaniesInModerated(moderatedCompaniesPageNumber, props.companies.moderatedCompanies.direction || 'desc');
          if (res) {
            props.companiesDataAdded({
              key: 'moderatedCompanies',
              data: combineDataToUniqueArray(props.companies.moderatedCompanies.data, res.data, 'companyId'),
              last: res.last,
              direction: directionStr,
            });
            setUpdateDataLoading(false);
          }
        } catch (res) {
          setUpdateDataLoading(false);
        }
      }

      if (activeTab === 2 && !props.companies.declinedCompanies.last) {
        setDeclinedCompaniesPageNumber(declinedCompaniesPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getDeclinedCompanies(declinedCompaniesPageNumber, props.companies.declinedCompanies.direction || 'desc');
          if (res) {
            props.companiesDataAdded({
              key: 'declinedCompanies',
              data: combineDataToUniqueArray(props.companies.declinedCompanies.data, res.data, 'companyId'),
              last: res.last,
              direction: directionStr,
            });
            setUpdateDataLoading(false);
          }
        } catch (res) {
          setUpdateDataLoading(false);
        }
      }
    }
  };

  useBottomScrollListener(handleOnDocumentBottom);

  useEffect(() => {
    if (activeTab === 0) {
      setDirectionStr(props.companies.moderatedCompanies.direction || 'desc');
    } else if (activeTab === 1) {
      setDirectionStr(props.companies.allCompanies.direction || 'desc');
    } else if (activeTab === 2) {
      setDirectionStr(props.companies.declinedCompanies.direction || 'desc');
    }
    const savedData = JSON.parse(sessionStorage.getItem(renderDataObjectName()));
    setDirectionStr(savedData?.direction || props.companies[renderDataObjectName()].direction || 'desc');
    sessionStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  useEffect(() => {
    if (sessionStorage.getItem(renderDataObjectName())) {
      const savedData = JSON.parse(sessionStorage.getItem(renderDataObjectName()));
      sessionStorage.setItem(renderDataObjectName(), JSON.stringify(savedData));
      props.changeDataByCompanyType({ key: renderDataObjectName(), data: { ...savedData } });
    }
  }, []);

  return (
    <CompaniesView
      companies={props.companies}
      activeTab={activeTab}
      updateDataLoading={updateDataLoading}
      banCompany={banCompany}
      setActiveTab={setActiveTab}
      acceptCompany={acceptCompany}
      refreshAction={refreshAction}
      sortCompanies={sortCompanies}
      directionRenderStr={directionRenderStr}
      directionStr={directionStr}
    />
  );
};

CompaniesContainer.propTypes = {
  companies: PropTypes.object,
  moderatedCompanies: PropTypes.object,
  moderatedCompaniesRemoveById: PropTypes.func,
  companiesDataChangeById: PropTypes.func,
  getModeratedCompanies: PropTypes.func,
  getAllCompanies: PropTypes.func,
  companiesDataAdded: PropTypes.func,
  changeValue: PropTypes.func,
  statistic: PropTypes.object,
  changeDataByCompanyType: PropTypes.object,
};
CompaniesContainer.defaultProps = {
  companies: {},
  moderatedCompanies: {},
  moderatedCompaniesRemoveById: () => {},
  companiesDataChangeById: () => {},
  getAllCompanies: () => {},
  getModeratedCompanies: () => {},
  changeValue: () => {},
  companiesDataAdded: () => {},
  statistic: {},
  changeDataByCompanyType: () => {},
};

const mapStateToProps = (store) => ({
  companies: store.companies,
  statistic: store.statistic,
});

const mapDispatchToProps = (dispatch) => ({
  moderatedCompaniesRemoveById: (payload) => dispatch(moderatedCompaniesRemoveById(payload)),
  companiesDataAdded: (payload) => dispatch(companiesDataAdded(payload)),
  companiesDataChangeById: (payload) => dispatch(companiesDataChangeById(payload)),
  getAllCompanies: () => dispatch(CompaniesHelper.getAllCompanies()),
  getModeratedCompanies: () => dispatch(CompaniesHelper.getModeratedCompanies()),
  getDeclinedCompanies: () => dispatch(CompaniesHelper.getDeclinedCompanies()),
  changeValue: (payload) => dispatch(changeValue(payload)),
  changeDataByCompanyType: (payload) => dispatch(changeDataByCompanyType(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompaniesContainer);
